import { memoize } from 'data/function';

class IndexByFilter {

    static factory() {
        'ngInject';
        const f = new IndexByFilter();
        return memoize(f.filter).bind(f);
    }

    filter(dictionary, index) {
        return index.map(i => dictionary[i]);
    }
}

export default IndexByFilter.factory;
